import React from "react";
import Button from "../common/imageButton";
import { FaCheck } from "react-icons/fa";

const QuizFrame = ({ question, option1, option2, onSelectOption, selectedOption }) => {
  return (
    <>
      <div className="relative lg:max-w-2xl mx-auto">
        {/* Background Image */}
        <img
          src="/images/quizFrame.png"
          alt="Background"
          className="w-full h-auto rounded-lg"
        />
        {/* Centered Text */}
        <div className="absolute inset-0 flex items-center justify-center">
          <p className="text-white text-center text-[15px] md:text-2xl font-normal drop-shadow-lg">
            {question}
          </p>
        </div>
      </div>

      {/* Buttons */}
      <div className="top-0 left-0 right-0 bottom-0 flex items-center justify-center gap-10 sm:gap-12 md:gap-20 mt-5">
        <div className="relative">
          <Button
            text={option1}
            onClick={() => onSelectOption(option1)}
            style={{
              backgroundColor: selectedOption === option1 ? "#4CAF50" : "#f1f1f1", // Highlight selected option
              color: selectedOption === option1 ? "#fff" : "#000",
            }}
          />
          {selectedOption === option1 && (
           <div className="absolute top-1/2 right-5 transform -translate-y-1/2">
           <FaCheck color="green" size={18} />
         </div>
          )}
        </div>
        <div className="relative">
          <Button
            text={option2}
            onClick={() => onSelectOption(option2)}
            style={{
              backgroundColor: selectedOption === option2 ? "#4CAF50" : "#f1f1f1", // Highlight selected option
              color: selectedOption === option2 ? "#fff" : "#000",
            }}
          />
          {selectedOption === option2 && (
            <div className="absolute top-1/2 right-5 transform -translate-y-1/2">
            <FaCheck color="green" size={18} />
          </div>
          )}
        </div>
      </div>
    </>
  );
};

export default QuizFrame;
